import React from "react";

const VisitUs = () => {
  return (
    <div id="visit-us" className="visit-section" data-aos="fade-up">
      <div className="visit-container">
        <div className="visit-info">
          <h3>📍 Visit Us</h3>
          <p className="tagline">We can’t wait to meet you!</p>

          <p>
            <strong>Address:</strong><br />
            Shivalik View, Ring road, Lane No. 2,<br />
            Opp. New Garhwal Sweets and Bakers,<br />
            Jogiwala, Dehradun
          </p>
          <p>
            <strong>📞 Call:</strong>{" "}
            <a href="tel:+917818875754" style={{ color: "#ea009c", fontWeight: "bold", textDecoration: "none" }}>
              +91 7818875754
            </a>
          </p>
          <p>
            <strong>📱 Text:</strong> <a href="sms:+917818875754" style={{ color: "#ea009c", fontWeight: "bold", textDecoration: "none" }}>
              +91 7818875754
            </a>
          </p>

          <h4>🕒 Hours:</h4>
          <ul>
            <li>Mon - Sat: 10 AM to 2 PM & 5:00 PM to 8:30 PM</li>
            <li>Sunday: 10 AM - 2 PM</li>
          </ul>

          <a
            href="tel:+917818875754"
            className="contact-btn"
            style={{
              display: "inline-block",
              marginTop: "1rem",
              background: "#ea009c",
              color: "#fff",
              borderRadius: "20px",
              padding: "0.7rem 1.5rem",
              fontWeight: "700",
              fontSize: "1.1rem",
              textDecoration: "none",
              boxShadow: "0 2px 8px rgba(234,0,156,0.08)",
              transition: "background 0.2s"
            }}
          >
            📞 Call Now
          </a>
        </div>

        <div className="visit-map">
          <iframe
            title="clinic-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.2517109538308!2d78.06362037535482!3d30.28689507480243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3909298ff650067f%3A0xe03af894ee0bc19c!2sDr%20Srishti&#39;s%20Dentistry%20%26%20Wellness%20Clinic!5e0!3m2!1sen!2sin!4v1744452226742!5m2!1sen!2sin"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VisitUs;